import { Link, Navigate } from '@tanstack/react-router'
import { useAuth } from '../auth/AuthContext.tsx'

export function PendingApprovalPage() {
  const { session } = useAuth()
  if (session) return <Navigate to="/" />

  return (
    <div className="app-layout">
      <main className="app-main centered-page">
        <div className="card center">
          <h1>Pending approval</h1>
          <p>Your account is waiting for a club admin to approve it.</p>
          <p className="muted">You’ll be able to log in once approval is complete.</p>
          <Link to="/login" className="btn">Return to login</Link>
        </div>
      </main>
    </div>
  )
}
